import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsfreemiumstatusbadgesvg = lazy(
  () => import('./svg-components/digital-forms-freemium-status-badge-svg')
);

const DigitalFormsFreemiumStatusBadgeSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsfreemiumstatusbadgesvg {...rest} />
  </Suspense>
);

export default DigitalFormsFreemiumStatusBadgeSvg;
